import { Button, Checkbox, Col, DatePicker, Form, Input, InputNumber, Pagination, Radio, Row, Select, Space, Table, Tabs } from 'antd';
import React, { useState } from 'react';
import { Link, useLoaderData, useOutletContext } from 'react-router-dom';
import RowEditableTable from '../../../globalComponents/RowEditableTable';
import usePutAwayRules from '../../apis/putAwayRules';

const columns = [
  {
    title: 'When product arrives in',
    dataIndex: 'product_received_location_id',
    key: 'product_received_location_id',
    editable: true,
    width: '15%',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Product',
    dataIndex: 'product_id',
    key: 'product_id',
    editable: true,
    width: '15%',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Product Category',
    dataIndex: 'category_id',
    key: 'category_id',
    editable: true,
    width: '10%',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Package Type',
    dataIndex: 'package_type_id',
    key: 'package_type_id',
    editable: true,
    width: '10%',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Store to sublocation',
    dataIndex: 'sublocation_id',
    key: 'sublocation_id',
    editable: true,
    width: '15%',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Outlet',
    dataIndex: 'outlet_id',
    key: 'outlet_id',
    editable: true,
    width: '15%',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: '',
    key: 'operation',
    // editable: true,
    fixed: 'right',
    // width: 100,
    className: 'whitespace-nowrap font-medium text-dark-600 dark:text-white',
  }
]


const PutAwayRules = () => {
  const {putAwayRules, products, locations} = useLoaderData();
  const [editingKey, setEditingKey] = useState('');
  const [putAwayRule, setPutAwayRules] = useState(putAwayRules);
  const { success, error } = useOutletContext();
  const { create } = usePutAwayRules();


  const onClick = (record) => {
    let data = {...record};
    create(data, success)  
    // console.log(data);
  }

  const addLine = () => {
    let putAwayRule_ = [...putAwayRule];
    let obj = {
      key: putAwayRule.length + 1,
      product_received_location_id: '',
      product_id: '',
      category_id: '',
      package_type_id: '',
      sublocation_id: '',
      outlet_id: '',
    };
    putAwayRule_.push(obj);
    setPutAwayRules(putAwayRule_);
    setEditingKey(putAwayRule.length + 1);
  }

  return (
    <div>
      <div className='flex justify-between mx-4'>
        <h3 className='font-bold'>Putaway Rules</h3>
        <div className=' bg-white dark:bg-gray-900'>
          {/* <Input addonBefore={<MdFilterAlt />}  defaultValue="mysite" /> */}

          <Select
            mode='multiple'
            size={'middle'}
            placeholder='Filter'
            // defaultValue={['a10', 'c12']}
            // onChange={handleChange}
            className='w-96'
            options={[]}
          />
        </div>
      </div>
      <div className='columns-2 mx-4 my-2'>
        <div className='column'>
          <Button className='' size={'sm'} onClick={addLine}>New</Button>
        </div>
        <div className='dark:bg-gray-900 column'>
          <div className='flex justify-end'>
            <Pagination  total={50} />
          </div>
        </div>
      </div>
      <RowEditableTable
        dataSource={putAwayRule}
        setDataSource={setPutAwayRules}
        columns={columns}
        editingKey={editingKey}
        setEditingKey={setEditingKey}
        options={{products: products, users: [], locations: locations,}}
        routes = {[]}
        triggers = {[]}
        onClick={onClick}
      />
    
    </div>
  )
}

export default PutAwayRules;